import { ChangeDetectorRef, Component, OnInit, TemplateRef, ViewChild, ViewContainerRef, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastsManager } from 'ng2-toastr';
import { Observable } from 'rxjs/Observable';
import { GuardModel, IncidentGuardModel, IncidentModel, ModuleModel } from '../../models';
import { AccountService, GuardService, ModuleService, SettingsService, SiteService, UserService } from '../../services';
import { AuthenticationService } from '../../services/authentication.service';
import { IncidentService } from '../../services/incident.service';
import { QrCodeService } from '../../services/qrcode.service';
import { modalIssueClass, modalSmall } from '../../shared/modules/dialogOptions';

@Component({
    selector: 'app-mobile-landing',
    templateUrl: './landing.component.html',
    styleUrls: ['../layout/mobile.css', '../layout/layout.component.scss']
})
export class MobileLandingComponent implements OnInit {
    sites: any[];
    isLoading: boolean = true;
    startRondProcessing: boolean = false;
    SiteId: number = 0;
    enableCustomEventBtns: boolean = false;
    moduleIds: number[] = [];
    roleDailyReport: any = {
        Name: '',
        Description: ''
    };
    roleIssues: any = {
        Name: '',
        Description: ''
    };

    roleLoans: any = {
        Name: '',
        Description: ''
    };
    isDecoding = false

    modalreference: NgbModalRef;
    popupMessageContent: any
    forLogout: boolean = false

    currentUser: any

    @ViewChild('popUp') popContent: TemplateRef<any>;
    module: ModuleModel;
    constructor(
        private modalService: NgbModal,
        private router: Router,
        private route: ActivatedRoute,
        private settingService: SettingsService,
        private authService: AuthenticationService,
        private siteService: SiteService,
        private cdRef: ChangeDetectorRef,
        private toastr: ToastsManager,
        private guardService: GuardService,
        private incidentService: IncidentService,
        private qrService: QrCodeService,
        private userService: UserService,
        private accountService: AccountService,
        //private authenticationService: AuthenticationService,
        private authenticationService: AuthenticationService,
        private moduleService: ModuleService,
        private sanitizer: DomSanitizer,
        private vRef: ViewContainerRef
    ) {
        this.toastr.setRootViewContainerRef(vRef)
    }
    public ngOnInit() {
        navigator.geolocation.getCurrentPosition(pos => { }) //to prompt location permission
        this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
        if (!this.currentUser?.welcomeMessageRead && this.currentUser.popupMessage) {
            setTimeout(() => {
                this.popupMessageContent = this.sanitizer.bypassSecurityTrustHtml(this.currentUser.popupMessage?.replace('\"', '"'));
                this.modalService.open(this.popContent, modalIssueClass)
                // this.accountService.getAccountPopupMessage(currentUser.accountId).subscribe((x: any) => {
                //     this.popUpMessage = this.sanitizer.bypassSecurityTrustHtml(x.Login?.replace('\"', '"'));
                //     this.popUpMessageLogout = this.sanitizer.bypassSecurityTrustHtml(x.Logout?.replace('\"', '"'));

                // })
            }, 800);
        }

        this.initialize();
        this.loadRole();
        this.loadDailyReportCustomButtons();

    }

    public navigateLoansList() {
        this.router.navigate([`mobile/loans/list`]);
    }

    public navigateEventList() {
        this.router.navigate([`mobile/daily-report/list`]);
    }

    public navigateCreateNewLoan() {
        this.router.navigate([`mobile/loans/create`]);
    }

    editUser() {
        let id = this.currentUser.id;
        if (id > 0) {
            this.router.navigate([`users/${id}/edit`]);
        }
    }

    public navigateIncidentsList() {
        //this.router.navigate([`mobile/loans/preview`]);
    }

    public navigateCreateIncident() {
        //this.router.navigate([`mobile/loans/return`]);
    }

    public loadDailyReportCustomButtons() {
        this.settingService.getValue('StartRond', this.currentUser.accountId)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {
                }, 1000);
            })
            .subscribe((response: any) => {

                var res = response.Data.Value.split("-");

                if (res[0] == "" || res[1] == "" || res[2] == "") {
                    this.enableCustomEventBtns = false;
                }

                if (res[0] == "0" || res[1] == "0" || res[2] == "0") {
                    this.enableCustomEventBtns = false;
                }

                this.settingService.getValue('StopRond', this.currentUser.accountId)
                    .catch((err: any) => {
                        return Observable.throw(err);
                    })
                    .finally(() => {
                        setTimeout(() => {
                        }, 1000);
                    })
                    .subscribe((response: any) => {

                        var res2 = response.Data.Value.split("-");

                        if (res2[0] == "" || res2[1] == "" || res2[2] == "") {
                            this.enableCustomEventBtns = false;
                        }
                        if (res2[0] == "0" || res2[1] == "0" || res2[2] == "0") {
                            this.enableCustomEventBtns = false;
                        }

                    });
            });

        this.enableCustomEventBtns = true;
    }

    public saveChanges(setting: string): void {

        this.startRondProcessing = true;
        this.settingService.getValue(setting, this.currentUser.accountId)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {
                }, 1000);
            })
            .subscribe((response: any) => {

                var res = response.Data.Value.split("-");

                this.guardService.getByName(this.currentUser.displayName, this.SiteId)
                    .catch((err: any) => {
                        return Observable.throw(err);
                    })
                    .finally(() => {
                        setTimeout(() => {
                        }, 1000);
                    })
                    .subscribe((guardResponse: any) => {

                        var model = new IncidentModel();
                        model.AccountId = this.currentUser.accountId;
                        model.SiteId = this.SiteId;
                        model.Type1Id = res[0];
                        model.Type2Id = res[1];
                        model.Type3Id = res[2];
                        model.ActionDescription = res[3];
                        var incidentGuard = new IncidentGuardModel();

                        if (guardResponse.Data == null) {
                            incidentGuard.Guard = new GuardModel();
                            incidentGuard.Guard.SiteId = this.SiteId;
                            incidentGuard.Guard.Name = this.currentUser.displayName;
                        } else {
                            //  
                            // incidentGuard = guardResponse.Data;
                            incidentGuard.GuardId = guardResponse.Data.Id;
                        }

                        model.IncidentGuard = [incidentGuard];

                        this.incidentService.saveIncident(model)
                            .catch((err: any) => {
                                //this.toastr.error(err, 'Error');
                                return Observable.throw(err);
                            }).finally(() => {
                                setTimeout(() => {
                                    //this.showSpinner = false;
                                }, 1000);
                            })
                            .subscribe((response) => {

                                this.startRondProcessing = false;
                                this.toastr.success(response.Message, "Event Added");

                            });

                    });

            });
    }

    public navigateToScanPage() {
        this.router.navigate([`mobile/qr/${this.SiteId}`]);
    }

    public navigateDailyReportCreateNew() {
        this.router.navigate([`incidents/create/${this.SiteId}`]);
    }
    public navigateIssueCreateNew() {
        this.router.navigate([`mobile/issue/create`]);
    }

    loadSites(accountId: number) {
        this.moduleIds = [];
        var user = JSON.parse(localStorage.getItem('currentUser'));

        this.moduleService.getModuleByTitle("Daily Report")
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {

                }, 1000);
            })
            .subscribe((resp: any) => {
                var mod = resp.Data;
                this.moduleIds.push(mod.Id);


                this.moduleService.getModuleByTitle("Issues")
                    .catch((err: any) => {
                        return Observable.throw(err);
                    })
                    .finally(() => {
                        setTimeout(() => {

                        }, 1000);
                    })
                    .subscribe((resp: any) => {
                        var mod = resp.Data;
                        this.moduleIds.push(mod.Id);


                        this.moduleService.getModuleByTitle("Loans")
                            .catch((err: any) => {
                                return Observable.throw(err);
                            })
                            .finally(() => {
                                setTimeout(() => {

                                }, 1000);
                            })
                            .subscribe((resp: any) => {
                                var mod = resp.Data;
                                this.moduleIds.push(mod.Id);

                                // 
                                var dataTosend = {
                                    accountId: accountId,
                                    userId: user.id,
                                    moduleId: this.moduleIds
                                };

                                localStorage.setItem("mobileData", JSON.stringify(dataTosend));

                                this.siteService.getByAccountIdAndUserIdModuleArray(dataTosend)
                                    .catch((err: any) => {
                                        return Observable.throw(err);
                                    })
                                    .finally(() => {
                                        setTimeout(() => {

                                        }, 1000);
                                    })
                                    .subscribe((response: any) => {

                                        this.isLoading = false;
                                        this.sites = response.Data;

                                        if (this.sites.length > 0) {
                                            this.cdRef.detectChanges();
                                            //this.PageOk = true;
                                            this.cdRef.detectChanges();
                                        }

                                        if (this.SiteId == null || this.SiteId == 0) {

                                            if (this.sites == undefined || this.sites.length == 0) {
                                                return;
                                            }

                                            if (this.sites.filter(x => x.Id == this.SiteId).length <= 0) {
                                                this.SiteId = this.sites[0].Id;
                                                localStorage.setItem('currentSiteId', this.SiteId.toString());
                                                this.loadRole();
                                                this.initialize();
                                            }

                                        } else {
                                            if (this.sites.filter(x => x.Id == this.SiteId).length == 0) {

                                                this.SiteId = this.sites[0].Id;
                                                localStorage.setItem('currentSiteId', this.SiteId.toString());
                                            }
                                        }

                                        localStorage.setItem('IncidentcurrentSiteId', this.SiteId.toString())

                                    });


                            });

                    });

            });

    }

    loadRole() {

        this.moduleService.getModuleByTitle("Daily Report")
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {

                }, 1000);
            })
            .subscribe((response: any) => {

                this.module = response.Data;

                // 
                //let currentUser = super.currentLoggedUser();
                var currentUser = JSON.parse(localStorage.getItem('currentUser'));

                this.authenticationService.getRole(currentUser.id, this.module.Id, this.SiteId)
                    .catch((err: any) => {
                        return Observable.throw(err);
                    })
                    .finally(() => {
                        setTimeout(() => {

                        }, 1000);
                    })
                    .subscribe((response: any) => {
                        // 
                        this.roleDailyReport = response.Data;

                        //this.incidentList.role = this.role;
                    });


            });


        this.moduleService.getModuleByTitle("Issues")
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {

                }, 1000);
            })
            .subscribe((response: any) => {

                this.module = response.Data;

                // 
                //let currentUser = super.currentLoggedUser();
                var currentUser = JSON.parse(localStorage.getItem('currentUser'));

                this.authenticationService.getRole(currentUser.id, this.module.Id, this.SiteId)
                    .catch((err: any) => {
                        return Observable.throw(err);
                    })
                    .finally(() => {
                        setTimeout(() => {

                        }, 1000);
                    })
                    .subscribe((response: any) => {

                        this.roleIssues = response.Data;

                        //this.incidentList.role = this.role;
                    });


            });



        this.moduleService.getModuleByTitle("Loans")
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {

                }, 1000);
            })
            .subscribe((response: any) => {

                this.module = response.Data;

                // 
                //let currentUser = super.currentLoggedUser();
                var currentUser = JSON.parse(localStorage.getItem('currentUser'));

                this.authenticationService.getRole(currentUser.id, this.module.Id, this.SiteId)
                    .catch((err: any) => {
                        return Observable.throw(err);
                    })
                    .finally(() => {
                        setTimeout(() => {

                        }, 1000);
                    })
                    .subscribe((response: any) => {

                        this.roleLoans = response.Data;

                        //this.incidentList.role = this.role;
                    });


            });

    };

    reLoad() {
        localStorage.setItem('IncidentcurrentSiteId', this.SiteId.toString())
        localStorage.setItem('currentSiteId', this.SiteId.toString());
        this.initialize();
        this.loadRole();
        //this.loadIncidents();
    };

    initialize() {
        // 
        if (localStorage.getItem('currentSiteId') != null) {
            this.SiteId = +localStorage.getItem('currentSiteId');
            //alert(this.SiteId);
        }

        this.loadSites(this.currentUser.accountId);
    }

    showLogoutPopup() {
        this.forLogout = true
        if ((this.currentUser?.enabledPopupMessage ?? false) && this.currentUser.popupMessageLogout) {
            this.popupMessageContent = this.sanitizer.bypassSecurityTrustHtml(this.currentUser.popupMessageLogout?.replace('\"', '"'));
            this.modalService.open(this.popContent, modalSmall)
        }
        else {
            this.onLoggedout()
        }
    }

    onLoggedout() {
        if (this.currentUser.id === -1) {
            this.clean()
        }
        else {
            let model = {
                userId: this.currentUser.id
            };
            this.authService.logoff(model)
                .catch((err: any) => {
                    return Observable.throw(err);
                }).finally(() => {

                })
                .subscribe((response) => {
                    this.clean()
                });
        }
    }

    clean() {
        localStorage.removeItem('currentUser');
        localStorage.removeItem('isLoggedin');
        localStorage.removeItem('secondaryAdminUser');
    }

    disablePopup() {
        this.currentUser.welcomeMessageRead = true
        localStorage.setItem('currentUser', JSON.stringify(this.currentUser))

        if (this.forLogout) {
            this.onLoggedout()
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/mobile/landing.component.ts